<template>
    <div>
        <WiringsHeadersList @selectedHeaders="saveHeaders" :headers="headers" :storageKey="storageKey" />
        <v-data-table
            :no-data-text="'Проводок не найдено'"
            :loading-text="'Загружаем...'"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text':'Проводок на странице',
                'items-per-page-all-text': 'Все',
                'page-text': ``
            }"
            disable-sort
            :headers="enabledHeaders"
            :items="wiringsItems"
            :loading="loading"
            :items-per-page="-1"
            @click:row="(wData) => $router.push(wiringLink(wData.id))"
        >
            <template v-slot:item.id="{ item }">
                <router-link :to="wiringLink(item.id)" @click.native.stop>{{ item.id }}</router-link>
            </template>
            <template v-slot:item.comment="{ item }">
                <span class="wl-comment" :title="item.comment">{{ item.comment || '-' }}</span>
            </template>
            <template v-slot:item.actions="{ item }" >
                <div class="d-flex">
                    <WiringDialog title="Редактировать проводку" :wData="getWiringData(item.id)">
                        <template v-slot="{ disabled, attrs, on, click }">
                            <v-icon
                            small
                            :disabled="disabled"
                            :bind="attrs"
                            :on="on" 
                            @click.stop="click">
                            mdi-pencil</v-icon>
                        </template>
                    </WiringDialog>
                    <v-icon
                        class="ml-1"
                        small
                        @click.stop="handleClickDeleteIcon(item)"
                        >
                        mdi-delete
                    </v-icon>
                </div>
            </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
                <v-card-title class="text-h5">Вы действительно хотите удалить Проводку?</v-card-title>
                <v-card-actions>
                    <v-btn color="blue darken-1" @click="dialogDelete = false">Отмена</v-btn>
                    <v-btn color="blue darken-1" @click="deleteWiring()">ОК</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { wiringTypeDirDict, wiringType } from '@/components/register/WireDict';
import { wDelete } from '@/modules/Wirings';
import WiringsHeadersList from './WiringsHeadersList';
import { resolveHeaders } from './headers.js'
import WiringDialog from '@/components/wirings/WiringDialog';
import { localStorage } from '@/modules/storage.js'

export default {
    name: 'WiringsTable',
    props: ['wirings', 'loading', 'storageKey', 'fromProjectId'],
    components: { WiringsHeadersList, WiringDialog },
    data() {
        return {
            dialogDelete: false,
            selectedId: 1,
            headers: resolveHeaders(this.storageKey, localStorage.get(this.storageKey))
        }
    },
    methods: {
        saveHeaders(headers) {
            this.headers = JSON.parse(JSON.stringify(headers));
        },
        wiringLink(id) {
            return this.fromProjectId
                ? `/wiring/${id}?fromproject=${this.fromProjectId}`
                : `/wiring/${id}`;
        },
        handleClickDeleteIcon(wData) {            
            this.dialogDelete = true; 
            this.selectedId = wData.id;
        },
        async deleteWiring() {
            const res = await wDelete(this.selectedId);
            if(res === 200) {
                this.$emit('removeEntry', this.selectedId);
                this.dialogDelete = false;
            }
        },
        getWiringData(id) {
            return this.wirings.find((wData) => wData.id === id);
        }
    },
    computed: {        
        enabledHeaders() {
            return this.headers.filter(({enabled}) => enabled);
        },
        wiringsItems() {
            return this.wirings.map((wiring) => {
                const {sum, article, fund, paymentDate, paymentMethod, budgetYear, contractor, organization, type, typeDir, project, expert, contract, note, comment, createDate, contribution, accountNumber } = wiring.data || {};
                const formatter = new Intl.NumberFormat("ru", { style: "currency",currency: "RUB" });
                const dirTitle = (typeDir && wiringTypeDirDict[typeDir]) ? wiringTypeDirDict[typeDir].title : '-';
                return {
                id: wiring.id,
                sum: formatter.format(sum || 0) || '-',
                projectName: wiring.data?.projectMissing
                    ? `⚠ проект ${wiring.data.projectMissing}`
                    : (project?.name || project?.shortName || (project ? `#${project.id}` : '-')),
                paymentDate: paymentDate ? new Date(paymentDate).toLocaleDateString('ru-RU') : '-',
                paymentMethod: paymentMethod?.text || '-',
                budgetYear: budgetYear || '-',
                note: note || '-',
                comment: comment || note || '',
                contract: contract?.number || '-',
                contractor: contractor?.shortName || contractor?.fullName ||  '-',
                organization: organization?.shortName || organization?.fullName || '-',
                createDate: createDate ||  '-',
                type: wiringType?.[type] || '-',
                expert: expert?.fullName || '-',
                typeDir: `${dirTitle} - ${fund?.fund || '-'} - ${article?.article || '-'}`,
                contribution: contribution || '-',
                accountNumber: accountNumber || '-'
            }})
        },
        
    },
    beforeMount() {
    }
}
</script>

<style scoped>
    .wl-comment {
        display: inline-block;
        max-width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
    }
    .v-data-table >>> tr > td {
        font-size: 12px !important;
    }
    .v-data-table >>> tr > th,
    .v-data-table >>> tr > td {
        padding: 10px !important;
    }
    .v-data-table >>> tbody > tr:hover {
        cursor: pointer;
    }
</style>